import { initCustomComponent } from '@narvar/cth';

(async () => {
  const customComponent = await initCustomComponent({ syncHeight: true });
  const {
    path,
    width,
    height,
    fluid,
    positionTarget,
    targetingKey,
    targetingValue,
  } = customComponent.state.settings;
  if (
    !path ||
    typeof path !== 'string' ||
    (!fluid && !width && !height) ||
    (width && typeof width !== 'number') ||
    (height && typeof height !== 'number')
  ) {
    return null;
  }

  const adContainer = document.getElementById('display-ad');

  if (!fluid && width && height) {
    adContainer?.setAttribute(
      'style',
      `width: ${width.toString()}px; height: ${height.toString()}px; margin: 0 auto;`,
    );
  }

  // 'fluid' is essentially auto-sizing. for reference, see this doc:
  // https://developers.google.com/publisher-tag/guides/ad-sizes#fluid_ads
  const adDimensions: 'fluid' | [number, number] = fluid
    ? 'fluid'
    : [
        typeof width === 'number' ? width : 0,
        typeof height === 'number' ? height : 0,
      ];

  if (typeof window !== 'undefined') {
    window.googletag = window.googletag || { cmd: [] };
    googletag.cmd.push(function () {
      googletag
        .defineSlot(path, adDimensions, 'display-ad')!
        // positioning target (e.g., anchor, leaderboard)
        // for key-value targeting reference, see: https://developers.google.com/publisher-tag/guides/key-value-targeting
        .setTargeting(
          'pos',
          typeof positionTarget === 'string' ? positionTarget : '',
        )
        .addService(googletag.pubads());
      if (
        targetingKey &&
        typeof targetingKey === 'string' &&
        targetingValue &&
        typeof targetingValue === 'string'
      )
        googletag.pubads().setTargeting(targetingKey, targetingValue);
      googletag.enableServices();
      googletag.display('display-ad');

      // listen for ad load and only show "sponsored" if there's an ad
      googletag.pubads().addEventListener('slotOnload', (event) => {
        const slot = event.slot;
        if (slot && adContainer) {
          const sponsoredText = document.createElement('div');
          sponsoredText.innerText = 'Sponsored';

          // FIXME: hardcoded in the interest of time, but we may
          // eventually need to bring in retailer theming.
          sponsoredText.style.color = '#767676';
          sponsoredText.style.fontFamily = 'Helvetica, Arial, sans-serif';
          sponsoredText.style.fontSize = '0.75rem';
          sponsoredText.style.margin = '0.25rem 0';
          sponsoredText.style.textAlign = 'right';

          adContainer.after(sponsoredText);
        }
      });
    });
  }

  customComponent.signalContentLoaded();
})()
  // eslint-disable-next-line no-console
  .catch((e) => console.error(e));
